import { Box } from "@mui/material"
import React from "react"

interface OverlayProps {
  open: boolean
}

export default function Overlay({ open }: OverlayProps) {
  if (!open) return null

  return (
    <Box
      position="fixed"
      width="100%"
      height="100%"
      top={0}
      left={0}
      zIndex={1}
      sx={{
        backdropFilter: "blur(24px)",
        backgroundColor: "var(--colors-light-background-bg-overlay-2)",
      }}
    />
  )
}
